const stringDatatype = "xsd:string";
const intDatatype = "xsd:int";
const floatDatatype = "xsd:float";
const shortDatatype = "xsd:short";

let searchCheckAllreadySet = false;

function setInputFilter(textbox, inputFilter, errMsg) {
  [
    "input", "keydown", "keyup", "keypress",
    "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout",
  ].forEach(function (event) {
    textbox.addEventListener(event, function (e) {
      if (inputFilter(this.value)) {
        if (["keydown", "mousedown", "focusout"].indexOf(e.type) >= 0) {
          this.classList.remove("input-error");
          this.setCustomValidity("");
        }
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.classList.add("input-error");
        this.setCustomValidity(errMsg);
        this.reportValidity();
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}

function setSearchFieldType(valueType) {
  let searchInputCurrentValue = "";
  const searchInput = document.getElementById("searchInputField");

  if (searchInputCurrentValue != valueType) {
    searchCheckAllreadySet = false;
  }

  if (searchCheckAllreadySet == false) {
    if (valueType == shortDatatype) {
      searchInputCurrentValue = shortDatatype;
      setInputFilter(searchInput, (v) => /^-?\d*$/.test(v), "Bitte gebe eine Zahl ein");
    } else if (valueType == intDatatype) {
      searchInputCurrentValue = intDatatype;
      setInputFilter(searchInput, (v) => /^-?\d*$/.test(v), "Bitte gebe eine Zahl ein");
    } else if (valueType == stringDatatype) {
      searchInputCurrentValue = stringDatatype;
      setInputFilter(searchInput, (v) => /^[0-9A-Za-zÀ-ž ]*$/i.test(v), "Bitte gebe nur Text ein");
    } else if (valueType == floatDatatype) {
      searchInputCurrentValue = floatDatatype;
      setInputFilter(searchInput, (v) => /^-?\d*[.,]?\d*$/.test(v), "Bitte gib eine Kommazahl ein");
    } else {
      return false;
    }
    searchCheckAllreadySet = true;
  }
}

/**
 * Prüft ob Eigenschafts-Dropdown und Suchfeld korrekt befüllt sind.
 * Setzt Input-Filter passend zum XSD-Datentyp der gewählten Eigenschaft.
 * @returns {boolean} true wenn alle Felder gültig gesetzt sind
 */
export function checkInputFields() {
  let allInputsSet = true;
  const searchInput = document.getElementById("searchInputField");
  const attributesInput = document.getElementById("baumEigenschaft");

  if (!attributesInput || attributesInput.value === "") {
    attributesInput && (attributesInput.style.borderColor = "red");
    searchInput && (searchInput.disabled = true);
    allInputsSet = false;
  } else {
    attributesInput.style.borderColor = "";
    searchInput.disabled = false;
    setSearchFieldType(attributesInput.value);
  }

  if (!searchInput) {
    allInputsSet = false;
  } else {
    searchInput.style.borderColor = "";
  }

  return allInputsSet;
}
